import { render, staticRenderFns } from "./SkeletonSelectPhoneNumber.vue?vue&type=template&id=7b5c36c9&functional=true"
import script from "./SkeletonSelectPhoneNumber.vue?vue&type=script&lang=js"
export * from "./SkeletonSelectPhoneNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports